import React, { FC } from 'react';

import * as ST from './styled';

interface IProps {
    isOpen: boolean,
    onClose: () => void,
    onClick?: () => void,
    title: string,
    text: string | JSX.Element,
    btnText?: string,
    link?: string,
}

const YandexResultPopup: FC<IProps> = ({
    onClick,
    isOpen,
    onClose,
    title,
    btnText,
    text,
    link,
}) => {
    return (
        <ST.YandexPopup isOpen={isOpen} onClose={onClose}>
            <ST.Container>
                <ST.Title>{title}</ST.Title>
                <ST.Text>{text}</ST.Text>
                {/* @ts-ignore */}
                <ST.Button href={link} onClick={onClick} target='_blank' rel='noreferrer'>{btnText || 'Закрыть'}</ST.Button>
            </ST.Container>
        </ST.YandexPopup>
    );
};

export default YandexResultPopup;
